<template>
  <v-container fluid>
    <div class="d-flex mb-2">
      <h2 style="font-weight: 400">รายการประกาศ</h2>
    </div>
    <v-tabs v-model="tab" background-color="transparent">
      <v-tab :disabled="!isSystemTabEnabled">การปรับปรุงระบบ</v-tab>
      <v-tab :disabled="!isInternalTabEnabled">ประกาศภายใน</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        class="pa-4"
        style="height: calc(100vh - 215px); overflow-y: auto"
      >
        <v-expansion-panels v-if="announcementsSystem.length">
          <v-expansion-panel
            v-for="item in announcementsSystem"
            :key="item.announcement_uuid"
          >
            <v-expansion-panel-header>
              <div class="d-flex flex-column">
                <span>{{ item.title }}</span>
                <span class="caption grey--text">
                  {{ (item.sent_datetime || item.created_at) | dateTimeFormat }}
                </span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>{{ item.message }}</div>
              <div
                v-if="item.announcement_image && item.announcement_image.length"
                class="d-flex flex-wrap mt-2"
                style="gap: 8px"
              >
                <v-img
                  v-for="file in item.announcement_image"
                  :key="file.announcement_image_uuid"
                  :src="file.image_url"
                  max-width="200"
                  style="border: 1px solid #e0e0e0; border-radius: 5px"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div v-else class="text-center grey--text py-8">ไม่มีประกาศ</div>
        <div
          v-if="totalAnnouncementsSystem > itemsPerPage"
          class="d-flex justify-center align-center mt-4"
          style="gap: 8px"
        >
          <v-btn
            outlined
            icon
            small
            :disabled="pageSystem <= 1"
            @click="changePageSystem(pageSystem - 1)"
          >
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            outlined
            icon
            small
            :disabled="pageSystem * itemsPerPage >= totalAnnouncementsSystem"
            @click="changePageSystem(pageSystem + 1)"
          >
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-tab-item>
      <v-tab-item
        class="pa-4"
        style="height: calc(100vh - 215px); overflow-y: auto"
      >
        <v-expansion-panels v-if="announcementsInternal.length">
          <v-expansion-panel
            v-for="item in announcementsInternal"
            :key="item.announcement_uuid"
          >
            <v-expansion-panel-header>
              <div class="d-flex flex-column">
                <span>{{ item.title }}</span>
                <span class="caption grey--text">
                  {{ (item.sent_datetime || item.created_at) | dateTimeFormat }}
                </span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>{{ item.message }}</div>
              <div
                v-if="item.announcement_image && item.announcement_image.length"
                class="d-flex flex-wrap mt-2"
                style="gap: 8px"
              >
                <v-img
                  v-for="file in item.announcement_image"
                  :key="file.announcement_image_uuid"
                  :src="file.image_url"
                  max-width="200"
                  style="border: 1px solid #e0e0e0; border-radius: 5px"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div v-else class="text-center grey--text py-8">ไม่มีประกาศ</div>
        <div
          v-if="totalAnnouncementsInternal > itemsPerPage"
          class="d-flex justify-center align-center mt-4"
          style="gap: 8px"
        >
          <v-btn
            outlined
            icon
            small
            :disabled="pageInternal <= 1"
            @click="changePageInternal(pageInternal - 1)"
          >
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            outlined
            icon
            small
            :disabled="
              pageInternal * itemsPerPage >= totalAnnouncementsInternal
            "
            @click="changePageInternal(pageInternal + 1)"
          >
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

export default {
  name: 'AnnouncementList',
  data() {
    return {
      tab: 1,
      itemsPerPage: 10,
      pageSystem: 1,
      pageInternal: 1,
      hasLoadedAnnouncements: false,
    }
  },
  filters: {
    dateTimeFormat: function (value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isSystemTabEnabled() {
      return (
        !this.uiCtrl ||
        this.uiCtrl.isEnable('tab:::system-announcement:receiver')
      )
    },
    isInternalTabEnabled() {
      return !this.uiCtrl || this.uiCtrl.isEnable('tab:::announcement:receiver')
    },
    announcementsSystem() {
      return this.sortByLatest(
        this.$store.state.announcement.announcementsSystem
      )
    },
    announcementsInternal() {
      return this.sortByLatest(
        this.$store.state.announcement.announcementsInternal
      )
    },
    totalAnnouncementsSystem() {
      return this.$store.state.announcement.totalAnnouncementsSystem
    },
    totalAnnouncementsInternal() {
      return this.$store.state.announcement.totalAnnouncementsInternal
    },
  },
  watch: {
    uiCtrl: {
      immediate: true,
      handler(uiCtrl) {
        if (!uiCtrl) return

        if (
          this.tab === 0 &&
          !this.isSystemTabEnabled &&
          this.isInternalTabEnabled
        ) {
          this.tab = 1
        } else if (
          this.tab === 1 &&
          !this.isInternalTabEnabled &&
          this.isSystemTabEnabled
        ) {
          this.tab = 0
        }

        if (!this.hasLoadedAnnouncements) {
          this.loadData()
        }
      },
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'รายการประกาศ',
        disabled: true,
      },
    ])
  },
  mounted() {
    // TODO: Remove this check when the menu access control is implemented
    // if (this.uiCtrl && !this.uiCtrl.isEnable('menu:::announcement-list')) {
    //   this.$router.push({ name: 'Home' })
    // } else {
    //   this.loadData()
    // }
  },
  methods: {
    ...mapActions({
      fetchAnnouncementSystem: 'announcement/fetchAnnouncementSystem',
      fetchAnnouncementInternal: 'announcement/fetchAnnouncementInternal',
    }),
    sortByLatest(items) {
      return [...(items || [])].sort((a, b) => {
        const dateA = new Date(a.sent_datetime || a.created_at)
        const dateB = new Date(b.sent_datetime || b.created_at)
        return dateB - dateA
      })
    },
    getAuthCompanyAndEmployee() {
      const {
        company: { company_uuid },
        user: { uuid: employee_uuid },
      } = this.$store.state.authentication

      return { company_uuid, employee_uuid }
    },
    async loadAnnouncementSystem(page) {
      const { company_uuid, employee_uuid } = this.getAuthCompanyAndEmployee()

      await this.fetchAnnouncementSystem({
        company_uuid,
        employee_uuid,
        params: {
          limit: `${this.itemsPerPage},${(page - 1) * this.itemsPerPage}`,
          is_display_during_period: true,
        },
      })

      this.pageSystem = page
    },
    async loadAnnouncementInternal(page) {
      const { company_uuid, employee_uuid } = this.getAuthCompanyAndEmployee()

      await this.fetchAnnouncementInternal({
        company_uuid,
        employee_uuid,
        params: {
          limit: `${this.itemsPerPage},${(page - 1) * this.itemsPerPage}`,
          is_display_during_period: true,
        },
      })

      this.pageInternal = page
    },
    async changePageSystem(page) {
      try {
        this.$store.commit('SET_LOADING', true)
        await this.loadAnnouncementSystem(page)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.commit('SET_LOADING', false)
      }
    },
    async changePageInternal(page) {
      try {
        this.$store.commit('SET_LOADING', true)
        await this.loadAnnouncementInternal(page)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.commit('SET_LOADING', false)
      }
    },
    async loadData() {
      if (!this.uiCtrl || this.hasLoadedAnnouncements) return

      this.hasLoadedAnnouncements = true

      try {
        this.$store.state.loading = true

        const requests = []

        if (this.isSystemTabEnabled) {
          requests.push(this.loadAnnouncementSystem(1))
        }

        if (this.isInternalTabEnabled) {
          requests.push(this.loadAnnouncementInternal(1))
        }

        await Promise.all(requests)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.commit('SET_LOADING', false)
      }
    },
  },
}
</script>
